import { createAction, props } from '@ngrx/store'
import { GoogleAnalyticsItem } from './google-analytics.models'

export const trackViewItemListEvent = createAction('[GoogleAnalytics/Page] Track View Item List Event')

export const trackViewItemEvent = createAction(
  '[GoogleAnalytics/Page] Track View Item Event',
  props<{ item: GoogleAnalyticsItem }>(),
)

export const trackAddToCartEvent = createAction(
  '[GoogleAnalytics/Page] Track Add to Cart Event',
  props<{ item: GoogleAnalyticsItem }>(),
)

export const trackBeginCheckoutEvent = createAction(
  '[GoogleAnalytics/Page] Track Begin Checkout Event',
  props<{ item: GoogleAnalyticsItem }>(),
)

export const trackRemoveFromCartEvent = createAction(
  '[GoogleAnalytics/Page] Track Remove from Cart Event',
  props<{ item: GoogleAnalyticsItem }>(),
)

export const trackPurchaseEvent = createAction(
  '[GoogleAnalytics/Page] Track Purchase Event',
  props<{
    item: GoogleAnalyticsItem
    currency?: string
    value: number | string
    transaction_id?: string
    tax?: number | string
  }>(),
)
